import Vue from 'vue'
import VueRouter from 'vue-router'
import AdminRoutes from './routes/admin.js'
import UserRoutes from './routes/user.js'
import BaseRoutes from './routes/base.js'
import BoarderRoutes from './routes/boarder.js'

Vue.use(VueRouter)

const routes = AdminRoutes.concat(UserRoutes, BoarderRoutes, BaseRoutes)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkExactActiveClass: 'active'
})
router.beforeEach((to, from, next) => {
  const currentUser = JSON.parse(localStorage.getItem('user'))
  if (to.meta.auth === false && currentUser) {
    return next({ name: 'homepage' })
  }
  if (to.meta.roles && !currentUser) {
    return next({ name: 'login' })
  } else if (to.meta.roles && !to.meta.roles.includes(currentUser.roleId)) {
    return next('/403')
  } else {
    return next()
  }
})

export default router
